import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';

const initialState = {
  currentVOName: '',
};

const VOReducer = (state = initialState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }
  switch (type) {
    case REDUX_ACTIONS.SET_VO_NAME:
      return {
        ...state,
        currentVOName: payload,
      };

    case REDUX_ACTIONS.ON_VO_ENDS:
      return {
        ...state,
        currentVOName: '',
      };

    default:
      return state;
  }
};

export default VOReducer;
